<template>
        <b-card
        class="mb-4 shadow"
      >
        <b-button
            v-if="state === 'short' || state === 'long'"
            size="sm"
            @click="updateLog(state)"
            class="float-right ml-3"
            variant="outline-secondary"
            title="Refresh log"
        >
            <b-icon-arrow-repeat/>
        </b-button>

        <b-form-checkbox
            v-if="allowdetails"
            v-model="detailsToggle"
            switch
            size="md"
            class="float-right mt-1"
            style="user-select:none"
        >Full details</b-form-checkbox>



        <div class="text-align"
            style="user-select:none"
        >
            <b-spinner v-if="state === 'loading'"/>
            <span v-if="state === 'errorS'" class="text-warning">Error getting log</span> 
            <span v-if="state === 'errorL'" class="text-warning">Error getting detailed log</span> 
        </div>  

        <pre
            v-if="logtext"
            class="text-left"
            style="white-space:pre-line"
        >{{logtext}}</pre>
      </b-card>
</template>

<script>
import * as bs from 'bootstrap-vue';
import Vue from 'vue';

[
    bs.ButtonPlugin,
    bs.SpinnerPlugin,
    bs.CardPlugin,
].forEach(p=> Vue.use(p))

Vue.component('b-icon-arrow-repeat', bs.BIconArrowRepeat)

export default {
    props:['job-id','allowdetails'],
    data(){return {
        short:null,
        long:null,
        state:'loading',
    }},
    created() {
        this.state = 'short';
    },
    computed:{
        logtext(){
            switch(this.state){
                case 'short': return this.short
                case 'long': return this.long
                default: return null
            }
        },
        detailsToggle:{
            get(){
                switch (this.state) {
                    case 'errorS':
                    case 'short': return false;
                    case 'errorL':
                    case 'long': return true;
                    default: return null;
                }
            },
            set(t){
                if(t === true) this.state = 'long'
                if(t === false) this.state = 'short'
            },
        }
    },
    watch: {
        jobId(){
            this.short = null; 
            this.long =  null;
            this.state = 'loading';
            let self  = this;
            this.$nextTick(() => self.state = 'short')
        },
        state(newState){
            if(newState == 'long' && this.long === null) 
                this.updateLog('long')
            else if (newState == 'short' && this.short === null) 
                this.updateLog('short')
        }
    },
    methods:{
        updateLog(type){
            let self = this;
            if(type === 'short')
                    this.$api.shortlog(this.jobId).then(t => (self.short = t)).catch(() => self.state = 'errorS');
            else if(type === "long")
                    this.$api.longlog(this.jobId).then(t => (self.long = t)).catch(() => self.state = 'errorL');
        }
    }
}
</script>

<style>

</style>